define("ProductDetails.ImageGallery.View.Extension", [
  "ProductDetails.ImageGallery.View",
  "underscore",
  "jQuery",
  "Utils",
], function (ProductDetailsImageGalleryView, _, jQuery, Utils) {
  "use strict";
  _.extend(ProductDetailsImageGalleryView.prototype, {
    initialize: _.wrap(
      ProductDetailsImageGalleryView.prototype.initialize,
      function (fn) {
        fn.apply(this, _.toArray(arguments).slice(1));

        var isDragging360 = false;
        var startX360 = 0;
        var self = this;

        // Cache 360 image existence per item
        if (!ProductDetailsImageGalleryView._360ImageCache) {
          ProductDetailsImageGalleryView._360ImageCache = {};
        }

        // Pre-check if 360 images exist for this item
        var itemid = this.model.get("item").get("itemid");
        if (
          typeof ProductDetailsImageGalleryView._360ImageCache[itemid] ===
          "undefined"
        ) {
          this.check360ImageExists(itemid);
        }

        jQuery(document).on(
          "touchstart mousedown",
          ".3560-view-container",
          function (e) {
            isDragging360 = true;

            var touch = e.originalEvent.touches
              ? e.originalEvent.touches[0]
              : e;
            startX360 = touch.pageX;
          }
        );

        jQuery(document).on("touchmove mousemove", function (e) {
          if (!isDragging360) return;

          var touch = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
          var diff = Math.abs(touch.pageX - startX360);

          if (diff > 5) {
            e.stopPropagation();
            e.preventDefault();
          }
        });

        jQuery(document).on("touchend mouseup", function () {
          isDragging360 = false;
        });
      }
    ),

    check360ImageExists: function (itemid) {
      var domain = window.location.protocol + "//" + window.location.hostname;
      var imageUrl = domain + "/360-Images/" + itemid + "-001.jpg";
      var self = this;

      // Set default to false
      ProductDetailsImageGalleryView._360ImageCache[itemid] = false;

      var img = new Image();
      img.onload = function () {
        ProductDetailsImageGalleryView._360ImageCache[itemid] = true;
        // Re-render if this is the current item and cache was false before
        if (self.model.get("item").get("itemid") === itemid) {
          self.render();
          self.initSliderZoom(true);
        }
      };
      img.onerror = function () {
        ProductDetailsImageGalleryView._360ImageCache[itemid] = false;
      };
      img.src = imageUrl;
    },

    initSliderZoom: _.wrap(
      ProductDetailsImageGalleryView.prototype.initSliderZoom,
      function (fn, forceInit) {
        fn.apply(this, _.toArray(arguments).slice(1));

        // Initialize 360 viewer after slider is ready
        this.init360Viewer();
      }
    ),

    init360Viewer: function () {
      var self = this;

      // Wait a bit for DOM to be ready
      setTimeout(function () {
        if (window.CI360 && jQuery(".cloudimage-360").length) {
          try {
            // Destroy existing instances first
            if (window.CI360.destroy) {
              window.CI360.destroy();
            }
            // Re-initialize
            window.CI360.init();
          } catch (e) {
            console.warn("360 viewer initialization error:", e);
          }
        }
      }, 100);
    },

    initSlider: function initSlider(forceInit) {
      if (this.images.length > 1 && (!this.$slider || forceInit === true)) {
        // Destroy existing slider if it exists
        if (this.$slider && this.$slider.destroySlider) {
          this.$slider.destroySlider();
          this.$slider = null;
        }

        this.$slider = Utils.initBxSlider(this.$("[data-slider]"), {
          buildPager: _.bind(this.buildSliderPager, this),
          startSlide: 0,
          adaptiveHeight: true,
          touchEnabled: false,
          nextText:
            '<a class="product-details-image-gallery-next-icon" data-action="next-image"></a>',
          prevText:
            '<a class="product-details-image-gallery-prev-icon" data-action="prev-image"></a>',
          controls: true,
        });

        this.$('[data-action="next-image"]').off();
        this.$('[data-action="prev-image"]').off();

        this.$('[data-action="next-image"]').click(
          _.bind(this.nextImageEventHandler, this)
        );
        this.$('[data-action="prev-image"]').click(
          _.bind(this.previousImageEventHandler, this)
        );
      }
    },

    nextImageEventHandler: _.wrap(
      ProductDetailsImageGalleryView.prototype.nextImageEventHandler,
      function (fn, e) {
        fn.apply(this, _.toArray(arguments).slice(1));
      }
    ),

    getContext: _.wrap(
      ProductDetailsImageGalleryView.prototype.getContext,
      function (fn) {
        var originalRet = fn.apply(this, _.toArray(arguments).slice(1));

        // Check if originalRet.images has 360-view image already
        var has360View = originalRet.images.some(function (image) {
          return image.id === "360-view";
        });

        if (has360View) {
          return originalRet;
        }

        var itemid = this.model.get("item").get("itemid");

        // Check cache - only add if we know the image exists
        if (!ProductDetailsImageGalleryView._360ImageCache[itemid]) {
          return originalRet;
        }

        var domain = window.location.protocol + "//" + window.location.hostname;

        var image360 = {
          id: "360-view",
          class: "cloudimage-360 rotateimages-info-card-content",
          folder: domain + "/360-Images/",
          "data-filename": itemid + "-00{index}.jpg",
          "data-amount": "23",
          altimagetext: "360 View",
          url: domain + "/360-Images/" + itemid + "-001.jpg",
          is360: true,
        };

        var videoIndex = _.findIndex(originalRet.images, function (image) {
          return image.isVideo || image.video || image.type === "video";
        });

        if (videoIndex !== -1) {
          // Insert 360 BEFORE the video
          originalRet.images.splice(videoIndex, 0, image360);
        } else {
          // No video → add at the end
          originalRet.images.push(image360);
        }

        // originalRet.images.push({
        //   id: "360-view",
        //   class: "cloudimage-360 rotateimages-info-card-content",
        //   folder: domain + "/360-Images/",
        //   "data-filename": itemid + "-00{index}.jpg",
        //   "data-amount": "23",
        //   altimagetext: "360 View",
        //   url: domain + "/360-Images/" + itemid + "-001.jpg",
        //   is360: true,
        // });

        return originalRet;
      }
    ),
  });
});
